<template>
  <v-container class="EventsPage py-5">
    <h1>Events</h1>

    <v-responsive :aspect-ratio="3/2" class="mt-3">
      <v-calendar
        v-model="selectedDay"
        color="blue lighten-1"
      />
    </v-responsive>

    <h2 class="mt-10 mb-2">Selected day events</h2>
    <v-list v-if="selectedDayEvents" outlined>
      <v-list-item
        v-for="event in selectedDayEvents"
        :key="event._id"
      >
        <v-list-item-content>
          <v-list-item-title>{{ event.title }}</v-list-item-title>
          <v-list-item-subtitle>{{ event.description }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <div v-else>No events for selected day</div>
  </v-container>
</template>

<script>
// TODO implement events functionality
const events = [
  {
    day: new Date(),
    events: [
      {
        _id: '1',
        title: 'User registration',
        description: 'Current user was registered on the platform',
      },
    ],
  },
];

export default {
  name: 'EventsPage',
  data() {
    return {
      selectedDay: new Date(),
    };
  },
  computed: {
    selectedDayEvents() {
      const format = 'DD.MM.YYYY';
      const currentDay = this.$moment(this.selectedDay).format(format);
      const eventObj = events.find(e => this.$moment(e.day).format(format) === currentDay);
      return eventObj?.events;
    },
  },
};
</script>
